import styled from 'styled-components/macro';
import { TYPOGRAPHY, COLORS } from 'styleguide';

const Snooze = styled.button`
  width: 100%;
  padding: 8px;
  background: transparent;
  border: 0;
  color: #fff;
  cursor: pointer;
  ${TYPOGRAPHY.body}
  text-align: left;
  white-space: nowrap;
  transition: background-color 0.15s ease-out;

  &:hover {
    background-color: ${COLORS.black};
  }
`;

export default Snooze;
